// extracted by mini-css-extract-plugin
export default {"reviewPolicyBody":"dz6Vv"};